var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"contenido_principal_funcionarios"}),_c('pagina-construccion',{attrs:{"nombreApartado":"Funcionarios Públicos","enlace":"http://www.haciendachiapas.gob.mx/"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }